import vars from '../../vars';

$(document).ready(function() {

	vars.$asidePeriod.click(function() {
		var periodPosition = vars.$asidePeriods.offset();

		vars.$periods.css('top', (periodPosition.top - 120) + "px");

		vars.$periods.toggleClass("hide");
		$(this).toggleClass("show");
	});

	$(".b-periods__btn-close").click(function() {
		vars.$periods.addClass("hide");
		vars.$asidePeriod.removeClass("show");
	});

	$(".b-periods__btn-apply").click(function() {
		vars.$periods.addClass("hide");
		vars.$asidePeriod.removeClass("show");
	});

	if ($(window).width() < 1023) {
		vars.$asidePeriodPrevInput.removeAttr('disabled');
		vars.$asidePeriodNextInput.removeAttr('disabled');
	}
});


// WEBPACK FOOTER //
// ./src/js/pages/materials/aside-periods.js